import React, { useMemo } from "react";
import Select from "react-select";
import Creatable from "react-select/creatable";
import { withTranslation } from "react-i18next";

import CustomSelectStyles from "../Styles/CustomSelectStyles";
import ModuleSelectStyles from "../Styles/ModuleSelectStyles";
import FilterSelectStyles from "../Styles/FilterSelectStyles";
import FilterTypeToSearchStyles from "../Styles/FilterTypeToSearchStyles";

const resolveStyles = (location, style) => {
    if (location === "normal") {
        return style === "dropdown" ? CustomSelectStyles : ModuleSelectStyles;
    }
    if (location === "filterpanel") {
        return style === "dropdown" ? FilterSelectStyles : FilterTypeToSearchStyles;
    }
    return {};
};

const CommonSelector = ({
                            style,
                            componentLocation,
                            isModal,
                            placeholder,
                            name,
                            value,
                            defaultValue,
                            options,
                            getOptionLabel,
                            getOptionValue,
                            onChange,
                            onInputChange,
                            onFocus,
                            onBlur,
                            onMenuClose,
                            isClearable,
                            isSearchable,
                            isCreatable,
                            isInstanceReport,
                            inputId,
                            id,
                            ariaLabel,
                            ariaDescribedBy,
                            errorId,
                            hasError
                        }) => {
    const isMulti = useMemo(() => !["language", "customer", "user"].includes(name), [name]);
    const closeMenuOnSelect = useMemo(() => !isMulti, [isMulti]);
    const menuPortalTarget = isModal ? undefined : document.body;
    const styles = useMemo(() => resolveStyles(componentLocation, style), [componentLocation, style]);

    const sharedProps = {
        isMulti,
        placeholder,
        name,
        options,
        value,
        defaultValue,
        onChange,
        onInputChange,
        onFocus,
        onBlur,
        onMenuClose,
        isClearable,
        isSearchable,
        closeMenuOnSelect,
        menuPortalTarget,
        styles,
        getOptionLabel,
        getOptionValue,
        isDisabled: isInstanceReport,
        inputId,
        id,
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        "aria-invalid": hasError || undefined,
        "aria-errormessage": hasError && errorId ? errorId : undefined,
        noOptionsMessage: () => null
    };

    return (
        <div>
            {isCreatable ? (
                <Creatable {...sharedProps} />
            ) : (
                <Select
                    {...sharedProps}
                    className="basic-single"
                    classNamePrefix="select"
                />
            )}
        </div>
    );
};

export default withTranslation()(CommonSelector);